import styled from 'styled-components';

import { absCenter } from '@sorare/core/src/lib/style';

import checkmarkTile from '../assets/checkmarkTile.webp';

export const CheckmarkTile = styled.div`
  ${absCenter}
  width: 100%;
  height: 100%;
  background: url(${checkmarkTile}) no-repeat center / contain;
`;
